import { MeasurementTypeEnum } from "@/app/api/battery-portal-api";
export class MeasurementHelper {
    /**
     * Whether a measurement type (and its category) is offered for a system's battery type on the
     * Trend and Discharge pages. Mirrors the measurement category/type visibility filters on those pages.
     */
    static isMeasurementTypeAvailable(measurementType, isLithium, isLithiumSamsungG3) {
        if (!measurementType)
            return false;
        const categoryId = measurementType.measurementCategoryId || 0;
        const maxCategoryId = isLithium ? (isLithiumSamsungG3 ? Number.MAX_SAFE_INTEGER : 4) : 3;
        if (categoryId > maxCategoryId)
            return false;
        if (isLithium)
            return isLithiumSamsungG3 ? measurementType.visibleForLithiumSamsungGen3 : measurementType.visibleForLithium;
        return measurementType.visibleForNonLithium;
    }
    ;
    static getTemperatureLabel(imperial) {
        return imperial ? this.farenheit : this.celcius;
    }
    ;
    static convertToFahrenheit(temperature) {
        if (!temperature)
            return 0;
        return (temperature * 1.8) + 32;
    }
    ;
    static getRoundedValueString(value, digits = 2) {
        if (value == null)
            return "-";
        let result = parseFloat(`${value}`).toFixed(digits);
        return result;
    }
    ;
    static formatVoltage(value) {
        if (value == null)
            return "-";
        let digits = value < 10 ? 3 : value < 100 ? 2 : value < 1000 ? 1 : 0;
        return parseFloat(`${value}`).toFixed(digits);
    }
    ;
    static formatCurrent(value) {
        if (value == null)
            return "-";
        if (value < 1000) {
            return parseFloat(`${value}`).toFixed(1);
        }
        else {
            return parseFloat(`${value}`).toFixed(0);
        }
    }
    ;
    static getFormattedValueForUnitOfMeasurement(value, unitOfMeasurement) {
        if (value == null)
            return "";
        let digits = 2;
        switch (unitOfMeasurement) {
            case MeasurementTypeEnum.BlockVoltage:
            case MeasurementTypeEnum.BlockVoltageMedian:
            case MeasurementTypeEnum.BlockVoltageVariation:
            case MeasurementTypeEnum.CellSummationVoltage:
            case MeasurementTypeEnum.CellVoltageAverage:
            case MeasurementTypeEnum.CellVoltageMax1:
            case MeasurementTypeEnum.CellVoltageMax2:
            case MeasurementTypeEnum.CellVoltageMin1:
            case MeasurementTypeEnum.CellVoltageMin2:
            case MeasurementTypeEnum.ModuleVoltageVariation:
            case MeasurementTypeEnum.StringVoltage:
            case MeasurementTypeEnum.SystemMaxVoltage:
            case MeasurementTypeEnum.SystemMinVoltage:
            case MeasurementTypeEnum.StringVoltageVariation:
                return this.formatVoltage(value);
            case MeasurementTypeEnum.Current:
            case MeasurementTypeEnum.RippleCurrent:
            case MeasurementTypeEnum.SystemCurrent:
                return this.formatCurrent(value);
            case MeasurementTypeEnum.AmbientTemperature:
            case MeasurementTypeEnum.AmbientTemperatureMedian:
            case MeasurementTypeEnum.AmbientTemperatureStringMedianToBlockMedianVariation:
            case MeasurementTypeEnum.AmbientTemperatureVariation:
            case MeasurementTypeEnum.BlockTemperatureMedian:
            case MeasurementTypeEnum.BlockTemperatureVariation:
            case MeasurementTypeEnum.CellTemperatureAverage:
            case MeasurementTypeEnum.CellTemperatureMax1:
            case MeasurementTypeEnum.CellTemperatureMax2:
            case MeasurementTypeEnum.CellTemperatureMin1:
            case MeasurementTypeEnum.CellTemperatureMin2:
            case MeasurementTypeEnum.SystemMaxTemperature:
            case MeasurementTypeEnum.SystemMinTemperature:
            case MeasurementTypeEnum.Temperature:
                digits = 1;
                break;
            case MeasurementTypeEnum.Ohmic:
            case MeasurementTypeEnum.OhmicRise:
            case MeasurementTypeEnum.BlockOhmicVariation:
            case MeasurementTypeEnum.RippleVoltage:
            case MeasurementTypeEnum.Humidity:
                digits = 0;
                break;
            case MeasurementTypeEnum.SystemSOC:
            case MeasurementTypeEnum.SystemSOH:
            case MeasurementTypeEnum.StringSOC:
            case MeasurementTypeEnum.StringSOH:
                digits = 1;
                break;
        }
        return (value.toFixed(digits));
    }
    static getRoundedValueForChart(value) {
        if (!value)
            return 0;
        if (Number.isInteger(value))
            return Number.parseFloat((Math.ceil(value / 10) * 10).toFixed(0));
        // round to 0.5, upwards
        return Number.parseFloat((Math.ceil(value * 20) / 20).toFixed(3));
    }
    ;
    static getNiceNumber(value, precision) {
        try {
            let log = Math.log10(value);
            let exponent = Math.floor(value === Math.pow(10, Math.round(log)) ? Math.round(log) : log);
            let fraction = value / Math.pow(10, exponent);
            let tidyFraction = 1;
            if (precision) {
                if (fraction < 1.5)
                    tidyFraction = 1;
                else if (fraction < 3)
                    tidyFraction = 2;
                else if (fraction < 7)
                    tidyFraction = 5;
                else
                    tidyFraction = 10;
            }
            else if (fraction <= 1.0)
                tidyFraction = 1;
            else if (fraction <= 2)
                tidyFraction = 2;
            else if (fraction <= 5)
                tidyFraction = 5;
            else
                tidyFraction = 10;
            return tidyFraction * Math.pow(10, exponent);
        }
        catch (ex) {
            return value;
        }
    }
    ;
}
MeasurementHelper.celcius = "°C";
MeasurementHelper.farenheit = "°F";
